/**
 * Container Component
 * Mobile-First Container with Fixed Max-Widths
 */

import { ReactNode } from 'react';
import styles from './Container.module.css';

export interface ContainerProps {
  children: ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  padding?: boolean;
  className?: string;
}

export function Container({
  children,
  size = 'xl',
  padding = true,
  className = '',
}: ContainerProps) {
  return (
    <div
      className={`${styles.container} ${styles[`container-${size}`]} ${
        padding ? styles.containerPadding : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}

